import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";

import Color from "@tool/color";
import "./scss/index.scss";
import Title from "@/page/index/component/title";
import CommonTab from "@/page/index/component/common-Tab";
import moPortrait, { changePortraitActive } from "../../store/portrait";
import PortraitDispath from "./component/portrait-dispach";
import SexDistributon from "./component/sex-distribution";
import { isEmpty, round } from "lodash";
import TopRanking from "./component/top-ranking";
import Empty from "@/component/empty";

interface IProps {}
interface IState {}

// 人力需求
const TalentPortrait = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { portraitActive, categoryList, talentPortraitList } = moPortrait;
  const colorList = ["one", "two", "three", "four", "five"];
  const getResult = useMemo(() => {
    const age = talentPortraitList?.age?.map((item: any, i: number) => {
      const items: any = {};
      items.name = item.label;
      items.value = round(item?.ratio * 100, 1);
      items.prop = colorList[i];
      return items;
    });
    const education = talentPortraitList?.education?.map(
      (item: any, i: number) => {
        const items: any = {};
        items.name = item.label;
        items.value = round(item?.ratio * 100, 1);
        items.prop = colorList[i];
        return items;
      }
    );
    const gender = talentPortraitList?.gender?.map((item: any, i: number) => {
      const items: any = {};
      items.name = item.label;
      items.value = item?.ratio * 100;
      items.prop = colorList[i];
      return items;
    });

    const school = talentPortraitList?.school?.map((item: any, i: number) => {
      const items: any = {};
      items.name = item.label;
      items.value = round(item?.ratio * 100, 1);
      items.prop = colorList[i];
      return items;
    });
    return { age, education, gender, school };
  }, [talentPortraitList]);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="talent-portrait-warp">
      <section className="tops-title-warp" id="talent">
        <Title title="人才流动" subtitle="人才画像" />
      </section>
      <section className="portrait-warp">
        <section className="portrait-tab">
          <CommonTab
            list={categoryList}
            active={portraitActive}
            onChange={(val: string) => {
              changePortraitActive(val);
            }}
          />
        </section>
        <section className="svg-group">
          <PortraitDispath title="年龄分布" list={getResult.age} />
          <PortraitDispath title="学历分布" list={getResult.education} />
          <SexDistributon list={getResult.gender} />
          <PortraitDispath title="学校分布" list={getResult.school} />
        </section>
        <section className="hot-professiona-warp">
          <TopRanking />
        </section>
      </section>
    </section>
  );
};

export default observer(TalentPortrait);
